import React from 'react';
import { Skeleton } from 'freespace-react-components';

/**
 * Loading state component for signage
 * @param {Object} props - Component props
 * @param {React.RefObject} props.containerRef - Container reference
 * @returns {JSX.Element} Loading state component
 */
const LoadingState = ({ containerRef }) => (
  <div className='signage row panels panels-horizontal' style={{ margin: "0px" }}>
    <div ref={containerRef} style={{ 
      height: "100vh", 
      width: "100%", 
      display: "flex", 
      alignItems: "center", 
      justifyContent: "center" 
    }}>
      <div style={{ textAlign: 'center' }}>
        <Skeleton height="60px" />
        <p style={{ marginTop: "16px", color: "#6c757d" }}>Loading signage design...</p>
      </div>
    </div>
  </div>
);

export default LoadingState;
